
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[pillar]/[city]/directorio/[slug]",
      function () {
        return require("private-next-pages/[pillar]/[city]/directorio/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[pillar]/[city]/directorio/[slug]"])
      });
    }
  